"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const core = __importStar(require("@actions/core"));
const tc = __importStar(require("@actions/tool-cache"));
const exec = __importStar(require("@actions/exec"));
const io = __importStar(require("@actions/io"));
const path = __importStar(require("path"));
const fs = __importStar(require("fs"));
const download_version_1 = require("./download/download-version");
const restore_cache_1 = require("./restore-cache");
const utils_1 = require("./utils");
const download_latest_1 = require("./download/download-latest");
function run() {
    return __awaiter(this, void 0, void 0, function* () {
        const platform = (0, utils_1.getPlatform)();
        const arch = (0, utils_1.getArch)();
        const versionInput = core.getInput('version');
        const checkSum = core.getInput('checksum');
        const enableCache = core.getInput('enable-cache') === 'true';
        const cachePrefix = core.getInput('cache-prefix') || '';
        const githubToken = core.getInput('github-token');
        try {
            if (platform === undefined) {
                throw new Error(`Unsupported platform: ${process.platform}`);
            }
            if (arch === undefined) {
                throw new Error(`Unsupported architecture: ${process.arch}`);
            }
            const setupResult = yield setupRye(platform, arch, versionInput, checkSum, githubToken);
            setVersion(setupResult.version);
            addRyeToPath(setupResult.installedPath);
            addMatchers();
            yield ensureCleanConfig(setupResult.installedPath);
            if (enableCache) {
                yield (0, restore_cache_1.restoreCache)(cachePrefix, setupResult.version);
            }
        }
        catch (err) {
            core.setFailed(err.message);
        }
        process.exit(0);
    });
}
function setupRye(platform, arch, versionInput, checkSum, githubToken) {
    return __awaiter(this, void 0, void 0, function* () {
        let installedPath;
        let downloadPath;
        let version;
        if (versionInput === 'latest') {
            const result = yield (0, download_latest_1.downloadLatest)(platform, arch, checkSum, githubToken);
            version = result.version;
            downloadPath = result.downloadPath;
        }
        else {
            version = versionInput;
            installedPath = (0, download_version_1.tryGetFromCache)(arch, versionInput);
            if (installedPath) {
                core.info(`Found Rye in tools-cache for ${versionInput}`);
                return { version, installedPath };
            }
            downloadPath = yield (0, download_version_1.downloadVersion)(platform, arch, versionInput, checkSum, githubToken);
        }
        installedPath = yield installRye(downloadPath, arch, version);
        yield createConfigBackup(installedPath);
        return { version, installedPath };
    });
}
function installRye(downloadPath, arch, version) {
    return __awaiter(this, void 0, void 0, function* () {
        const tempDir = path.join(process.env['RUNNER_TEMP'] || '', 'rye_temp_home');
        yield io.mkdirP(tempDir);
        core.debug(`Created temporary directory ${tempDir}`);
        // Cache first to get the correct path
        const cachedPath = yield tc.cacheDir(tempDir, utils_1.toolsCacheName, version, arch);
        const toolchainVersion = yield determineToolchainVersion();
        const env = toolchainVersion
            ? Object.assign(Object.assign({}, process.env), { RYE_HOME: cachedPath, RYE_TOOLCHAIN_VERSION: toolchainVersion }) : Object.assign(Object.assign({}, process.env), { RYE_HOME: cachedPath });
        const options = {
            cwd: cachedPath,
            silent: !core.isDebug(),
            env: env
        };
        core.info(`Installing Rye into ${cachedPath}`);
        const execArgs = ['self', 'install', '--yes'];
        if ((0, utils_1.compareVersions)(version, utils_1.EARLIEST_VERSION_WITH_NO_MODIFY_PATHSUPPORT) >= 0) {
            execArgs.push('--no-modify-path');
        }
        yield exec.exec(downloadPath, execArgs, options);
        return cachedPath;
    });
}
function determineToolchainVersion() {
    return __awaiter(this, void 0, void 0, function* () {
        const pythonVersionFile = `${restore_cache_1.WORKING_DIR_PATH}${path.sep}.python-version`;
        if (fs.existsSync(pythonVersionFile)) {
            const toolchainVersion = yield fs.promises.readFile(pythonVersionFile, 'utf8');
            core.info(`Determined RYE_TOOLCHAIN_VERSION: ${toolchainVersion.trim()}`);
            return toolchainVersion.trim();
        }
        core.warning(`No .python-version file found, using default RYE_TOOLCHAIN_VERSION`);
        return;
    });
}
function createConfigBackup(installedPath) {
    return __awaiter(this, void 0, void 0, function* () {
        if (fs.existsSync(`${installedPath}${path.sep}${utils_1.RYE_CONFIG_TOML}`)) {
            yield io.cp(`${installedPath}${path.sep}${utils_1.RYE_CONFIG_TOML}`, `${installedPath}${path.sep}${utils_1.RYE_CONFIG_TOML_BACKUP}`);
            core.info(`Backed up ${installedPath}${path.sep}${utils_1.RYE_CONFIG_TOML}`);
        }
    });
}
function ensureCleanConfig(installedPath) {
    return __awaiter(this, void 0, void 0, function* () {
        if (fs.existsSync(`${installedPath}${path.sep}${utils_1.RYE_CONFIG_TOML_BACKUP}`)) {
            yield io.rmRF(`${installedPath}${path.sep}${utils_1.RYE_CONFIG_TOML}`);
            yield io.cp(`${installedPath}${path.sep}${utils_1.RYE_CONFIG_TOML_BACKUP}`, `${installedPath}${path.sep}${utils_1.RYE_CONFIG_TOML}`);
            core.info(`Restored clean ${utils_1.RYE_CONFIG_TOML} from ${installedPath}${path.sep}${utils_1.RYE_CONFIG_TOML_BACKUP}`);
        }
    });
}
function setVersion(version) {
    if (utils_1.VERSIONS_WHICH_MODIFY_PROFILE.includes(version)) {
        core.warning(`Rye version ${version} adds a wrong path to the file ~/.profile. Consider using version ${utils_1.EARLIEST_VERSION_WITH_NO_MODIFY_PATHSUPPORT} or later instead.`);
    }
    core.setOutput('rye-version', version);
}
function addRyeToPath(cachedPath) {
    core.addPath(`${cachedPath}${path.sep}shims`);
    core.info(`Added ${cachedPath}${path.sep}shims to the path`);
    core.exportVariable('RYE_HOME', cachedPath);
    core.info(`Set RYE_HOME to ${cachedPath}`);
}
function addMatchers() {
    const matchersPath = path.join(__dirname, `..${path.sep}..`, '.github');
    core.info(`##[add-matcher]${path.join(matchersPath, 'python.json')}`);
}
run();
